export class PartnerApplicationModel{
    PartnerApplicationID?:number;
    BusinessName!:string;
    FirstName!:string;
    LastName!:string;
    StoreID!:number;
    Address!:string;
    Mobile1!:string
    
    constructor(init?:Partial<PartnerApplicationModel>){
        Object.assign(this, init);
    }
}